import { RouteRecordRaw, RouteMeta, LocationQueryRaw } from 'vue-router'

export type MenuChildern = MenuType | RouteRecordRaw

/**
 * @description:
 * @param {*}
 *    meta: {
 *        showMenu: boolean // 控制菜单的展示，默认为展示*
 *        code: string // 用于路由鉴权
 *        id: 控制菜单的展开，唯一
 *    }
 * @return {*}
 */
export interface MenuType {
  meta?: RouteMeta
  code?: string
  name?: string
  icon?: string
  path?: string
  component?: RouteRecordRaw['component']
  children?: Array<MenuChildern>
}

// 这里的menu会用到 router 和 asider 两个地方
const getMenu = (): MenuType[] => {
  return [
    {
      name: '故障分析',
      meta: {
        id: 1666,
        code: '014002013',
        icon: 'FireOutlined'
      },
      children: [
        {
          name: '日志',
          path: '/TroubleShooting/Log/Index',
          meta: {
            id: 16661,
            icon: 'FileSearchOutlined',
            code: '014002013001'
          },
          component: () => import('@/view/TroubleShooting/Log')
        },
        {
          name: 'ClickHouse日志',
          path: '/TroubleShooting/ClickHouse/Index',
          meta: {
            id: 16662,
            icon: 'FileSearchOutlined',
            code: '014002013001'
          },
          component: () => import('@/view/TroubleShooting/ClickHouse')
        }
      ]
    },
    {
      name: 'Client Data Center',
      meta: {
        id: 178,
        code: '014002002',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: 'Client Request Analysis',
          meta: {
            id: 176,
            icon: 'AreaChartOutlined',
            code: '014002002001'
          },
          children: [
            {
              name: 'Client LTB',
              path: '/V2/L2B/Client',
              meta: {
                id: 177,
                icon: 'LineChartOutlined',
                code: '014002002001001'
              },
              component: () => import('@/view/V2/L2B/Client')
            },
            {
              name: 'Client Request Rank',
              path: '/V2/Rank/Client',
              meta: {
                id: 180,
                icon: 'BarChartOutlined',
                code: '014002002001002'
              },
              component: () => import('@/view/V2/Rank/Client')
            },
            {
              name: 'Client Request Trend',
              path: '/V2/Trend/Client',
              meta: {
                id: 181,
                icon: 'ProfileFilled',
                code: '014002002001003'
              },
              component: () => import('@/view/V2/Trend/Client')
            }
          ]
        },
        {
          name: 'Client Booking Analysis',
          meta: {
            id: 182,
            icon: 'SlidersOutlined',
            code: '014002002002'
          },
          children: [
            {
              name: 'Client Booking Rank',
              path: '/V2/BookingRank/Client',
              meta: {
                id: 183,
                icon: 'ProfileFilled',
                code: '014002002002001'
              },
              component: () => import('@/view/V2/BookingRank/Client')
            },
            {
              name: 'Client Booking Trend',
              path: '/V2/BookingTrend/Client',
              meta: {
                id: 184,
                icon: 'ProfileFilled',
                code: '014002002002002'
              },
              component: () => import('@/view/V2/BookingTrend/Client')
            },
            {
              name: 'Client Booking Tendency',
              path: '/V2/BookingTendency/Client',
              meta: {
                id: 326,
                icon: 'ProfileFilled',
                code: '014002002002003'
              },
              component: () => import('@/view/V2/BookingTendency/Client')
            }
          ]
        },
        {
          name: 'Client Commissions',
          path: '/V2/Commissions/Client',
          meta: {
            id: 204,
            icon: 'ProfileFilled',
            code: '014002002010'
          },
          component: () => import('@/view/V2/Commissions/Client')
        },
        {
          name: 'Client Credit Search',
          path: '/V2/Credit/Client',
          meta: {
            id: 2041,
            icon: 'ProfileFilled',
            code: '014002002003'
          },
          component: () => import('@/view/V2/Credit/Client')
        },
        // {
        //   name: '渠道供应商实时售卖监控',
        //   meta: {
        //     id: 2055,
        //     icon: 'SlidersOutlined',
        //     code: '014002002004'
        //   },
        //   children: [
        //     {
        //       name: '机构分类统计',
        //       path: '/OperateAnalysis/ClientEnableSupplierMonitor/ClientCategoryStat',
        //       meta: {
        //         id: 20551,
        //         icon: 'ProfileFilled',
        //         code: '014002002004001',
        //         goOld: true
        //       },
        //       component: () => import('@/view/V2/L2B/Supplier')
        //     },
        //     {
        //       name: '机构统计',
        //       path: '/OperateAnalysis/ClientEnableSupplierMonitor/ClientStat',
        //       meta: {
        //         id: 20552,
        //         icon: 'ProfileFilled',
        //         code: '014002002004002',
        //         goOld: true
        //       },
        //       component: () => import('@/view/V2/L2B/Supplier')
        //     },
        //     {
        //       name: '机构设置',
        //       path: '/OperateAnalysis/ClientEnableSupplierMonitor/ClientSettings',
        //       meta: {
        //         id: 20553,
        //         icon: 'ProfileFilled',
        //         code: '014002002004003',
        //         goOld: true
        //       },
        //       component: () => import('@/view/V2/L2B/Supplier')
        //     }
        //   ]
        // },
        {
          name: 'Client Hotel Availability',
          meta: {
            id: 2058,
            icon: 'SlidersOutlined',
            code: '014002002008'
          },
          children: [
            {
              name: '渠道有价率',
              path: '/base/menu/Index',
              meta: {
                id: 20581,
                icon: 'ProfileFilled',
                code: '014002002008001',
                query: { id: 0 }
              },
              component: () => import('@/view/base-menu/base-menu.component')
            }
          ]
        },
        {
          name: '海外客户进展管理',
          path: '/OperateAnalysis/ClientProcess/Overseas',
          meta: {
            id: 20582,
            icon: 'ProfileFilled',
            code: '014002002008002'
          },
          component: () => import('@/view/OperateAnalysis/CoreData/Oversea/clientList')
        },
        {
          name: '渠道不准请求明细导出(临时)',
          path: '/OperateAnalysis/rateAccuracyIssue/Index',
          meta: {
            id: 14002002011,
            icon: 'ProfileFilled',
            code: '014002002011'
          },
          component: () => import('@/view/OperateAnalysis/CoreData/Rate/index')
        },
        {
          name: '机构在线时长录入',
          path: '/OperateAnalysis/client/channelOnline',
          meta: {
            id: 14002002012,
            icon: 'ProfileFilled',
            code: '014002002012'
          },
          component: () => import('@/view/OperateAnalysis/Client/channelOnline')
        },
        {
          name: '机构在线时长 Dashboard',
          path: '/OperateAnalysis/client/channelOnline/dashboard',
          meta: {
            id: 14002002013,
            icon: 'ProfileFilled',
            code: '014002002013'
          },
          component: () => import('@/view/OperateAnalysis/Client/channelOnlineDashboard')
        }
      ]
    },
    {
      name: 'Supplier Data Center',
      meta: {
        id: 196,
        code: '014002003',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: 'Supplier Request Analysis',
          meta: {
            id: 197,
            icon: 'SlidersOutlined',
            code: '014002003001'
          },
          children: [
            {
              name: 'Supplier LTB',
              path: '/V2/L2B/Supplier',
              meta: {
                id: 198,
                icon: 'ProfileFilled',
                code: '014002003001001'
              },
              component: () => import('@/view/V2/L2B/Supplier')
            },
            {
              name: 'Supplier Request Rank',
              path: '/V2/Rank/Supplier',
              meta: {
                id: 199,
                icon: 'ProfileFilled',
                code: '014002003001002'
              },
              component: () => import('@/view/V2/Rank/Supplier')
            },
            {
              name: 'Supplier Request Trend',
              path: '/V2/Trend/Supplier',
              meta: {
                id: 200,
                icon: 'ProfileFilled',
                code: '014002003001003'
              },
              component: () => import('@/view/V2/Trend/Supplier')
            }
          ]
        },
        {
          name: 'Supplier Booking Analysis',
          meta: {
            id: 201,
            icon: 'SlidersOutlined',
            code: '014002003002'
          },
          children: [
            {
              name: 'Supplier Booking Rank',
              path: '/V2/BookingRank/Supplier',
              meta: {
                id: 202,
                icon: 'ProfileFilled',
                code: '014002003002001'
              },
              component: () => import('@/view/V2/BookingRank/Supplier')
            },
            {
              name: 'Supplier Booking Trend',
              path: '/V2/BookingTrend/Supplier',
              meta: {
                id: 203,
                icon: 'ProfileFilled',
                code: '014002003002002'
              },
              component: () => import('@/view/V2/BookingTrend/Supplier')
            },
            {
              name: 'Supplier Booking Tendency',
              path: '/V2/BookingTendency/Supplier',
              meta: {
                id: 325,
                icon: 'ProfileFilled',
                code: '014002003002003'
              },
              component: () => import('@/view/V2/BookingTendency/Supplier')
            }
          ]
        },
        {
          name: 'Supplier Commissions',
          path: '/V2/Commissions/Supplier',
          meta: {
            id: 206,
            icon: 'SlidersOutlined',
            code: '014002003011'
          },
          component: () => import('@/view/V2/Commissions/Supplier')
        },
        {
          name: 'Supplier Sale Promotion',
          path: '/V2/Promotion/Supplier',
          meta: {
            id: 206,
            icon: 'SlidersOutlined',
            code: '014002003013'
          },
          component: () => import('@/view/V2/Promotion/supplier')
        },
        {
          name: 'Supplier Target Dashboard',
          path: '/V2/Target/Supplier',
          meta: {
            id: 206,
            icon: 'SlidersOutlined',
            code: '014002003014'
          },
          component: () => import('@/view/V2/Target/supplier')
        },
        {
          name: 'Supplier Avail% & Adv% Dashboard',
          path: '/OperateAnalysis/SupplierRequest/Info',
          meta: {
            id: 207,
            icon: 'ProfileFilled',
            code: '014002003003'
          },
          component: () => import('@/view/OperateAnalysis/SupplierRequest/Info')
        },

        {
          name: '供应商机构监控',
          path: '/OperateAnalysis/SupplierClientOpenStatus/SupplierClientOpenStatus',
          meta: {
            id: 209,
            icon: 'ProfileFilled',
            code: '014002003005'
          },
          component: () =>
            import('@/view/OperateAnalysis/SupplierClientOpenStatus/SupplierClientOpenStatus')
        },
        {
          name: '自动调价结果分析',
          path: '/OperateAnalysis/AutoRateAdjust/ResultAnalysis',
          meta: {
            id: 210,
            icon: 'ProfileFilled',
            code: '014002003006'
          },
          component: () => import('@/view/OperateAnalysis/AutoRateAdjust/ResultAnalysis')
        },

        {
          name: 'Supplier Destination',
          path: '/OperateAnalysis/Destination/Index',
          meta: {
            id: 205,
            icon: 'ProfileFilled',
            code: '014002003010'
          },
          component: () => import('@/view/OperateAnalysis/DestinationSupplier/index')
        },
        {
          name: '供应商额度看板',
          path: '/OperateAnalysis/SupplierCreditReview/Index',
          meta: {
            id: 205,
            icon: 'ProfileFilled',
            code: '014002003012'
          },
          component: () => import('@/view/OperateAnalysis/Finance/SupplierCreditReviewBoard/index')
        },
        {
          name: 'EBK供应商额度看板',
          path: '/OperateAnalysis/SupplierEBKCreditReview/Index',
          meta: {
            id: 205,
            icon: 'ProfileFilled',
            code: '014002003012'
          },
          component: () =>
            import('@/view/OperateAnalysis/Finance/SupplierCreditReviewBoard/EBKIndex')
        }
      ]
    },
    {
      name: '市场数据中心',
      meta: {
        id: 1888,
        code: ['014002004', '014002017'],
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: '线下订单与请求中心',
          meta: {
            id: 18881,
            icon: 'SlidersOutlined',
            code: '014002004001'
          },
          children: [
            {
              name: '查定比',
              path: '/V2/L2B/Offline',
              meta: {
                id: 188811,
                icon: 'ProfileFilled',
                code: '014002004001001'
              },
              component: () => import('@/view/V2/L2B/Offline')
            },
            {
              name: '请求排行',
              path: '/V2/Rank/Offline',
              meta: {
                id: 188812,
                icon: 'ProfileFilled',
                code: '014002004001002'
              },
              component: () => import('@/view/V2/Rank/Offline')
            },
            {
              name: '请求趋势',
              path: '/V2/Trend/Offline',
              meta: {
                id: 188813,
                icon: 'ProfileFilled',
                code: '014002004001003'
              },
              component: () => import('@/view/V2/Trend/Offline')
            },
            {
              name: '订单排行',
              path: '/V2/BookingRank/Offline',
              meta: {
                id: 188814,
                icon: 'ProfileFilled',
                code: '014002004001004'
              },
              component: () => import('@/view/V2/BookingRank/Offline')
            },
            {
              name: '订单趋势',
              path: '/V2/BookingTrend/Offline',
              meta: {
                id: 188815,
                icon: 'ProfileFilled',
                code: '014002004001005'
              },
              component: () => import('@/view/V2/BookingTrend/Offline')
            }
          ]
        },
        {
          name: '线下CRM数据中心',
          path: '/base/menu/Index',
          meta: {
            id: 1889,
            icon: 'SlidersOutlined',
            code: '014002004002',
            query: { id: 11 }
          },
          children: [
            {
              name: '热销酒店排行',
              path: '/MarketDataCenter/CRMDataCenter/HotHotel',
              meta: {
                id: 18891,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 166
                }
              },
              //component: () => import('@/view/base-menu/base166')
              component: () => import('@/view/MarketDataCenter/CRMDataCenter/HotHotel')
            },
            {
              name: '机构请求与产单',
              path: '/MarketDataCenter/CRMDataCenter/ClientLookToBook',
              meta: {
                id: 18893,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 165
                }
              },
              //component: () => import('@/view/base-menu/base165')
              component: () => import('@/view/MarketDataCenter/CRMDataCenter/ClientLookToBook')
            },
            {
              name: '核心数据对比',
              path: '/MarketDataCenter/CRMDataCenter/CoreDataComparison',
              meta: {
                id: 18894,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 167
                }
              },
              //component: () => import('@/view/base-menu/base167')
              component: () => import('@/view/MarketDataCenter/CRMDataCenter/CoreDataComparison')
            },
            {
              name: '客户注册与活跃度',
              path: '/MarketDataCenter/CRMDataCenter/RegistrationAndActivity',
              meta: {
                id: 18895,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 171
                }
              },
              //component: () => import('@/view/base-menu/base171')
              component: () =>
                import('@/view/MarketDataCenter/CRMDataCenter/RegistrationAndActivity')
            },
            {
              name: '热销城市分析',
              path: '/MarketDataCenter/CRMDataCenter/HotCity',
              meta: {
                id: 18896,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 174
                }
              },
              //component: () => import('@/view/base-menu/base174')
              component: () => import('@/view/MarketDataCenter/CRMDataCenter/HotCity')
            },
            {
              name: '机构产量对比',
              path: '/MarketDataCenter/CRMDataCenter/OutputComparison',
              meta: {
                id: 18892,
                icon: 'ProfileFilled',
                code: '014002004002',
                query: {
                  //id: 175
                }
              },
              //component: () => import('@/view/base-menu/base165')
              component: () => import('@/view/MarketDataCenter/CRMDataCenter/OutputComparison')
            }
          ]
        },
        // {
        //   name: '官网资源与用户分析',
        //   path: '/OperateAnalysis/ClientHotelReportMonitor/Index',
        //   meta: {
        //     id: 1890,
        //     icon: 'ProfileFilled',
        //     code: '014002004003',
        //     goOld: true
        //   }
        // },
        {
          name: '额度查询',
          path: '/V2/Credit/Offline',
          meta: {
            id: 1891,
            icon: 'ProfileFilled',
            code: '014002004004'
          },
          component: () => import('@/view/V2/Credit/Offline')
        },
        {
          name: '国内客户注册和激活情况',
          path: '/OperateAnalysis/ClientProcess/China',
          meta: {
            id: 1892,
            icon: 'ProfileFilled',
            code: '014002004004'
          },
          component: () => import('@/view/OperateAnalysis/CoreData/China/clientDashboard')
        }
      ]
    },
    {
      name: '内部检测报告',
      meta: {
        id: 'Internal Report',
        code: '014002018',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: '渠道投放建议分析',
          path: '/OperateAnalysis/OverallCheck/Internal/V1',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018001',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/internalV1')
        },
        {
          name: '渠道资源漏斗分析',
          path: '/OperateAnalysis/OverallCheck/Internal/ChannelFunnel',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018004',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/channelFunnel')
        },
        {
          name: '供应商指标分析',
          path: '/OperateAnalysis/OverallCheck/Internal/Target',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018003',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/IntervalV2')
        },

        {
          name: '外部热销机会分析',
          path: '/OperateAnalysis/ExternalhotAnalysis/ExternalhotAnalysis',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018002',
            requireAuth: true,
            showLayout: true
          },
          component: () =>
            import(
              '@/view/OperateAnalysis/ApiMedicalReportIn/ExternalhotAnalysis/ExternalhotAnalysis'
            )
        },
        {
          name: 'EBK核心指标看板',
          path: '/OperateAnalysis/OverallCheck/Internal/Ebk',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018005',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/ebkOverallCheck')
        },
        {
          name: '供应商资源配置分析',
          path: '/OperateAnalysis/OverallCheck/Internal/Supplier',
          meta: {
            id: 14002005008,
            icon: 'SlidersOutlined',
            code: '014002018006',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/supplier')
        }
      ]
    },

    {
      name: 'General Use通用查询',
      meta: {
        id: 221,
        code: '014002005',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: 'Production Report ',
          path: '/OperateAnalysis/ProductionReportMonitor/Index',
          meta: {
            id: 222,
            icon: 'ProfileFilled',
            code: '014002005001'
          },
          component: () => import('@/view/OperateAnalysis/ProductionReportMonitor/Index')
        },
        {
          name: 'RateShop',
          path: '/OperateAnalysis/RateShop/RateShop',
          meta: {
            icon: 'ProfileFilled',
            code: '014002005002'
          },
          component: () => import('@/view/OperateAnalysis/RateShop')
        },
        {
          name: 'RateShopV2',
          path: '/OperateAnalysis/RateShop2/RateShopV2',
          meta: {
            icon: 'ProfileFilled',
            code: '014002005003',
            requireAuth: true
          },
          component: () => import('@/view/OperateAnalysis/RateShopV2')
        },
        {
          name: 'Indicator Analysis',
          meta: {
            id: 2210,
            icon: 'SlidersOutlined',
            code: '014002005004'
          },
          children: [
            {
              name: 'Failed Booking Report',
              path: '/OperateAnalysis/FailBooking/Index',
              meta: {
                id: 22101,
                icon: 'ProfileFilled',
                code: '014002005004001'
              },
              component: () => import('@/view/OperateAnalysis/FailBooking/index')
            }
          ]
        },
        // {
        //   name: 'Overview',
        //   path: '/OperateAnalysis/Overview/Index',
        //   meta: {
        //     id: 2210,
        //     icon: 'ProfileFilled',
        //     code: '014002005005'
        //   },
        //   component: () => import('@/view/OperateAnalysis/Overview/Index')
        // },
        {
          name: 'Detail',
          path: '/OperateAnalysis/Overview/Detail',
          meta: {
            id: 22101,
            icon: 'ProfileFilled',
            code: '014002005005',
            hiddenInMenu: true
          },
          component: () => import('@/view/OperateAnalysis/Overview/Detail')
        },
        {
          name: '供应商体检报告',
          path: '/OperateAnalysis/ProductionReportMonitor/SupplierInspectionReport',
          meta: {
            id: 14002005006,
            icon: 'ProfileFilled',
            code: '014002005006',
            requireAuth: true,
            showLayout: true
          },
          component: () =>
            import('@/view/OperateAnalysis/ProductionReportMonitor/SupplierInspectionReport')
        },
        {
          name: 'Api Client体检报告',
          path: '/OperateAnalysis/OverallCheck/ApiClient',
          meta: {
            id: 14002005007,
            icon: 'ProfileFilled',
            code: '014002005007',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/Client')
        },
        {
          name: 'Shopping Client体检报告',
          path: '/OperateAnalysis/OverallCheck/ShoppingClient',
          meta: {
            id: 14002005008,
            icon: 'ProfileFilled',
            code: '014002005008',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/shopping')
        },
        {
          name: 'SS供应商信息漏斗',
          path: '/OperateAnalysis/Supplier/Static',
          meta: {
            id: 14002005010,
            icon: 'ProfileFilled',
            code: '014002005010',
            requireAuth: true,
            showLayout: true
          },
          component: () => import('@/view/OperateAnalysis/SupplierEarnings/staticDashboard')
        },
        {
          name: '报告展示页面（开发用）',
          meta: {
            id: 'forDev',
            code: 'forDevExportPage',
            icon: 'SlidersOutlined'
          },
          children: [
            {
              name: '供应商体检报告展示',
              path: '/OperateAnalysis/OverallCheck/SupplierInspectionReportPage',
              meta: {
                id: 140020050060,
                icon: 'ProfileFilled',
                code: '140020050060',
                requireAuth: true,
                showLayout: false,
                searchAuth: true
              },
              component: () =>
                import(
                  '@/view/OperateAnalysis/ProductionReportMonitor/SupplierInspectionReportPage'
                )
            },
            {
              name: 'Api Client 体检报告展示',
              path: '/OperateAnalysis/OverallCheck/clientReport',
              meta: {
                id: 140020050060,
                icon: 'ProfileFilled',
                code: '140020050060',
                requireAuth: true,
                showLayout: false,
                searchAuth: true
              },
              component: () => import('@/view/OperateAnalysis/OverallCheck/clientReport')
            },
            {
              name: 'Shopping 体检报告展示',
              path: '/OperateAnalysis/OverallCheck/shoppingReport',
              meta: {
                id: 14002005008,
                icon: 'ProfileFilled',
                code: '14002005008',
                requireAuth: true,
                showLayout: false,
                searchAuth: true
              },
              component: () => import('@/view/OperateAnalysis/OverallCheck/shoppingReport')
            },
            {
              name: 'Shopping 英文体检报告展示',
              path: '/OperateAnalysis/OverallCheck/shoppingReport/en',
              meta: {
                id: 14002005008,
                icon: 'ProfileFilled',
                code: '14002005008',
                requireAuth: true,
                showLayout: false,
                searchAuth: true
              },
              component: () => import('@/view/OperateAnalysis/OverallCheck/shoppingReport_en')
            },
            {
              name: '体检报告展示封面',
              path: '/OperateAnalysis/ProductionReportMonitor/ReportCover',
              meta: {
                id: 14002005009,
                icon: 'ProfileFilled',
                code: '14002005009',
                requireAuth: false,
                showLayout: false,
                searchAuth: false
              },
              component: () => import('@/view/OperateAnalysis/ProductionReportMonitor/ReportCover')
            },
            {
              name: '体检报告展示目录页面',
              path: '/OperateAnalysis/ProductionReportMonitor/ReportCatelog',
              meta: {
                id: 14002005010,
                icon: 'ProfileFilled',
                code: '14002005010',
                requireAuth: false,
                showLayout: false,
                searchAuth: false
              },
              component: () =>
                import('@/view/OperateAnalysis/ProductionReportMonitor/ReportCatelog')
            }
          ]
        }
      ]
    },
    {
      name: '收益中心',
      meta: {
        id: 235,
        code: '014002008',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: '捞单订单汇总',
          meta: {
            id: 236,
            code: '014002008001',
            icon: 'SlidersOutlined',
            requireAuth: true
          },
          path: '/OperateAnalysis/Reorder/ReorderHistorySummary',
          component: () => import('@/view/income-center/ReorderHistorySummary')
        },
        {
          name: '结算争议订单',
          meta: {
            id: 237,
            code: '014002008002',
            icon: 'SlidersOutlined'
          },
          children: [
            {
              name: '渠道争议订单',
              meta: {
                id: 238,
                code: '014002008002001',
                icon: 'ProfileFilled',
                requireAuth: true
              },
              path: '/OperateAnalysis/DisputeBooking/ReceivableDisputeBooking',
              component: () => import('@/view/disputeBooking/RectivableDisputeBooking')
            },
            {
              name: '供应商争议订单',
              meta: {
                id: 239,
                code: '014002008002002',
                icon: 'ProfileFilled',
                requireAuth: true
              },
              path: '/OperateAnalysis/DisputeBooking/PayableDisputeBooking',
              component: () => import('@/view/disputeBooking/PayableDisputeBooking')
            },
            {
              name: '争议订单分析',
              meta: {
                id: 240,
                code: '014002008002003',
                icon: 'ProfileFilled',
                requireAuth: true
              },
              path: '/OperateAnalysis/DisputeBooking/Summary',
              component: () => import('@/view/disputeBooking/Summary')
            },
            {
              name: '争议订单数据',
              meta: {
                id: 241,
                code: '014002008002003',
                icon: 'ProfileFilled',
                requireAuth: true
              },
              path: '/OperateAnalysis/DisputeBooking/datas',
              component: () => import('@/view/disputeBooking/bookingData')
            }
          ]
        },
        {
          name: '超赔订单分析',
          meta: {
            id: 238,
            code: '014002008001',
            icon: 'SlidersOutlined',
            requireAuth: true
          },
          path: '/OperateAnalysis/DisputeBooking/OverCompensationSummary',
          component: () => import('@/view/disputeBooking/OverCompensationSummary')
        },
        {
          name: '利润监控',
          meta: {
            id: 241,
            code: '014002008003',
            icon: 'SlidersOutlined'
          },
          children: [
            {
              name: '表格汇总',
              meta: {
                id: 242,
                code: '014002008003001',
                icon: 'ProfileFilled'
              },
              path: '/OperateAnalysis/ProfitMonitor/List',
              component: () => import('@/view/OperateAnalysis/ProfitMonitor/List')
            },
            {
              name: '趋势列表',
              meta: {
                id: 242,
                code: '014002008003002',
                icon: 'ProfileFilled'
              },
              path: '/OperateAnalysis/ProfitMonitor/Chart',
              component: () => import('@/view/OperateAnalysis/ProfitMonitor/Chart')
            }
          ]
        },
        {
          name: '渠道利润监控',
          meta: {
            id: 242,
            code: '014002008005',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          path: '/OperateAnalysis/Earnings/Index',
          component: () => import('@/view/OperateAnalysis/Earnings/Index')
        },
        {
          name: '供应商利润监控',
          meta: {
            id: 244,
            code: '014002008006',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          path: '/OperateAnalysis/SupplierEarnings/Index',
          component: () => import('@/view/OperateAnalysis/SupplierEarnings/Index')
        },
        {
          name: '供应商酒店利润监控',
          meta: {
            id: 244,
            code: '014002008007',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          path: '/OperateAnalysis/SupplierEarnings/Hotel',
          component: () => import('@/view/OperateAnalysis/Earnings/SupplierHotel')
        },
        {
          name: 'BRG数据分析',
          meta: {
            id: 243,
            code: '014002008004',
            icon: 'ProfileFilled',
            hiddenInMenu: true
          },
          path: '/OperateAnalysis/BRG/Summary',
          component: () => import('@/view/OperateAnalysis/BRG/BRG')
        },
        {
          name: 'BRG数据分析描述',
          meta: {
            id: 2431,
            code: '0140020080041',
            icon: 'ProfileFilled',
            requireAuth: false,
            hiddenInMenu: true
          },
          path: '/OperateAnalysis/BRG/Desc',
          component: () => import('@/view/OperateAnalysis/BRG/Desc')
        }
      ]
    },
    {
      name: '客服数据中心',
      meta: {
        id: 22111,
        icon: 'SlidersOutlined',
        code: '014002009'
      },
      children: [
        {
          name: 'KPI数据看板',
          meta: {
            id: 221110,
            icon: 'SlidersOutlined',
            code: '014002009001'
          },
          children: [
            {
              name: '工作台客服看板',
              path: '/Kangaroo/KPI/CustomerRankStatistics',
              meta: {
                id: 2211101,
                icon: 'ProfileFilled',
                code: '014002009005'
              },
              component: () => import('@/view/Kangaroo/CustomeRankStatistics')
            },
            // {
            //   name: 'KPI报表(准备废弃)',
            //   path: '/Kangaroo/KPI/report',
            //   meta: {
            //     id: 2211102,
            //     icon: 'ProfileFilled',
            //     code: '014002009001002'
            //   },
            //   component: () => import('@/view/Kangaroo/kpiReport')
            // },
            {
              name: 'KPI报表-V2',
              path: '/Kangaroo/KPI/report-v2',
              meta: {
                id: 2211104,
                icon: 'ProfileFilled',
                code: '014002009001002'
              },
              component: () => import('@/view/Kangaroo/KpiReport/kpiReport')
            },
            {
              name: '客服工时统计(按业务线)',
              path: '/Kangaroo/CustomerDataBoard/CustomerWorkingRatio',
              meta: {
                id: 2211103,
                icon: 'ProfileFilled',
                code: '014002009001002'
              },
              component: () => import('@/view/Kangaroo/CustomerDataBoard/CustomerWorkingRatio')
            }
          ]
        },
        {
          name: 'SOP数据看板',
          meta: {
            id: 221111,
            icon: 'SlidersOutlined',
            code: '014002009001'
          },
          children: [
            {
              name: 'Sop使用率统计',
              path: '/Kangaroo/KPI/SopUsageReport',
              meta: {
                id: 2211111,
                icon: 'ProfileFilled',
                code: '014002009005'
              },
              component: () => import('@/view/Kangaroo/SopUsageReport')
            }
          ]
        },
        {
          name: '呼叫中心',
          meta: {
            id: 221113,
            icon: 'PhoneFilled',
            code: '014002009002'
          },
          children: [
            {
              name: '客服日志',
              path: '/base/menu/customeLog',
              meta: {
                id: 2211131,
                icon: 'ProfileFilled',
                code: '014002009002001',
                query: { id: 77 }
              },
              component: () => import('@/view/base-menu/base159')
            },
            // {
            //   name: '电话趋势报表',
            //   path: '/Kangaroo/Ticket/BookingTicketTrend',
            //   meta: {
            //     id: 2211134,
            //     icon: 'ProfileFilled',
            //     code: '014002009002004'
            //   },
            //   component: () => import('@/view/base-menu/base159')
            // },
            //{
            //  name: '客服报表',
            //  path: '/base/menu/customeReport',
            //  meta: {
            //    id: 2211135,
            //    icon: 'ProfileFilled',
            //    code: '014002009002005',
            //    query: { id: 85 }
            //  },
            //  component: () => import('@/view/base-menu/base159')
            //},
            {
              name: '客服报表',
              path: '/Kangaroo/CustomerServerReport',
              meta: {
                id: 2211135,
                icon: 'ProfileFilled',
                code: '014002009002005',
              },
              component: () => import('@/view/Kangaroo/CustomerServerReport/index.vue')
            },
            // {
            //   name: '技能组报表',
            //   path: '/base/menu/SkillGroupReport',
            //   meta: {
            //     id: 2211136,
            //     icon: 'ProfileFilled',
            //     code: '014002009002006',
            //     query: { id: 86 }
            //   },
            //   component: () => import('@/view/base-menu/base159')
            // },
            // {
            //   name: '通话记录',
            //   path: '/Kangaroo/Ticket/BookingTicketTrend',
            //   meta: {
            //     id: 2211137,
            //     icon: 'ProfileFilled',
            //     code: '014002009002007'
            //   },
            //   component: () => import('@/view/base-menu/base159')
            // },
            {
              name: '客服工时利用率',
              path: '/base/menu/WorkUtilization',
              meta: {
                id: 2211138,
                icon: 'ProfileFilled',
                code: '014002009002008',
                query: { id: 107 }
              },
              component: () => import('@/view/base-menu/base159')
            },
            {
              name: '坐席登录情况',
              path: '/Kangaroo/AgentLoginSituationReport',
              meta: {
                id: 221113,
                icon: 'ProfileFilled',
                code: '014002009002'
              },
              component: () => import('@/view/Kangaroo/AgentLoginSituationReport/index.vue')
            },
            {
              name: '电话状态趋势图',
              path: '/Kangaroo/CallCenter/OnlineAgentAndCallTrendReport',
              meta: {
                id: 2211148,
                icon: 'ProfileFilled',
                code: '014002009002'
              },
              component: () => import('@/view/Kangaroo/CallCenter/OnlineAgentAndCallTrendReport.vue')
            },
            {
              name: '坐席监控历史记录',
              path: '/Kangaroo/CallCenter/AgentStatusLogAnalysisReport',
              meta: {
                id: 2211148,
                icon: 'ProfileFilled',
                code: '014002009002'
              },
              component: () => import('@/view/Kangaroo/CallCenter/AgentStatusLogAnalysisReport.vue')
            },
          ]
        },
        {
          name: '工单',
          path: '/',
          meta: {
            id: 221114,
            icon: 'SlidersOutlined',
            code: '014002009003'
          },
          children: [
            {
              name: '工单核心数据看板',
              path: '/Kangaroo/CoreDataBoard',
              meta: {
                id: 2211145,
                icon: 'ProfileFilled',
                code: '014002009003005'
              },
              component: () => import('@/view/Kangaroo/CoreDataBoard')
            },
            {
              name: '客诉数据看板',
              path: '/Kangaroo/ComplaintCoreDataBoard',
              meta: {
                id: 2211147,
                icon: 'ProfileFilled',
                code: '014002009003005'
              },
              component: () => import('@/view/Kangaroo/ComplaintCoreDataBoard')
            },
            {
              name: '工单问题类型占比',
              path: '/Kangaroo/Ticket/TicketIssueProportionTrend',
              meta: {
                id: 2211142,
                icon: 'ProfileFilled',
                code: '014002009003',
                goOld: true
              }
            },
            {
              name: '工单各小组平均处理时长',
              path: '/Kangaroo/Ticket/TicketProcessTime',
              meta: {
                id: 2211144,
                icon: 'ProfileFilled',
                code: '014002009003',
                goOld: true
              }
            },
            {
              name: '工单跟进报告',
              path: '/Kangaroo/Ticket/TicketFollowReport',
              meta: {
                id: 2211145,
                icon: 'ProfileFilled',
                code: '014002009003',
                goOld: true
              }
            },
            {
              name: '工单监控中心',
              path: '/Kangaroo/Ticket/TicketCountTrend',
              meta: {
                id: 2211146,
                icon: 'ProfileFilled',
                code: '014002009003',
                goOld: true
              }
            },
            {
              name: '客户满意度看板',
              path: '/Kangaroo/SatisfactionDataBoard',
              meta: {
                id: 2211148,
                icon: 'ProfileFilled',
                code: '014002009003'
              },
              component: () => import('@/view/Kangaroo/SatisfactionDataBoard/index.vue')
            }
          ]
        },
        {
          name: '二次确认数据监控',
          path: '/base/menu/Index',
          meta: {
            id: 221115,
            icon: 'PhoneFilled',
            code: '014002009004',
            query: { id: 7 }
          },
          children: [
            {
              name: '工单问题类型统计',
              path: '/base/menu/WorkOrderType',
              meta: {
                id: 2211151,
                icon: 'ProfileFilled',
                code: '014002009004001',
                query: { id: 93 }
              },
              component: () => import('@/view/base-menu/base159')
            },

            {
              name: '准确率',
              path: '/base/menu/Accuracy',
              meta: {
                id: 2211153,
                icon: 'ProfileFilled',
                code: '014002009004003',
                query: { id: 98 }
              },
              component: () => import('@/view/base-menu/base159')
            }
          ]
        }
      ]
    },
    {
      // 直签数据中心
      name: 'DC Data Center',
      meta: {
        code: '014002007',
        icon: 'SlidersOutlined',
        id: 'DC Data Center'
      },
      children: [
        {
          name: 'Location MM KPI report',
          path: '/OperateAnalysis/DCDataReport/Location',
          meta: {
            id: 'Location MM KPI report',
            icon: 'ProfileFilled',
            code: '014002007002001'
          },
          component: () => import('@/view/DC-Data-Center/Kpi/location')
        },
        {
          name: 'DC Chain Dashboard',
          path: '/OperateAnalysis/DCChainDashboard/Index',
          meta: {
            id: 'DCChainDashboard',
            icon: 'ProfileFilled',
            code: '014002007002001'
          },
          component: () => import('@/view/DC-Data-Center/Kpi/chainDashboard')
        },
        {
          name: 'DC Connectivity Dashboard',
          path: '/OperateAnalysis/DCDataReport/Connectivity',
          meta: {
            id: 'DC Connectivity Dashboard',
            icon: 'ProfileFilled',
            code: '014002007002001'
          },
          component: () => import('@/view/DC-Data-Center/Kpi/connectivity')
        },
        {
          name: 'DC country Report',
          path: '/DCCenter/CountryReport/index',
          meta: {
            id: 'DC country Report',
            icon: 'SlidersOutlined',
            code: ['014002007002003']
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/dcTargetOverallCheck')
        },
        {
          name: 'DC Hotel Monitoring',
          path: '/DCCenter/KeyHotHotel/index',
          meta: {
            id: 'DC Staring at the market',
            icon: 'SlidersOutlined',
            code: ['014002007002003']
          },
          component: () => import('@/view/OperateAnalysis/OverallCheck/dcStaringAtTheMarket')
        },
        {
          name: 'Destination Hotel Status',
          path: '/OperateAnalysis/DCHotelHealthy/Index',
          meta: {
            id: 'Hotel Status Healthy',
            icon: 'ProfileFilled',
            code: '014002007011',
            requireAuth: true
          },
          component: () => import('@/view/DC-Data-Center/Hotel-Healthy/index')
        },
        {
          name: 'Destination Avail% & Adv% Dashboard',
          path: '/OperateAnalysis/DestinationAvail/Index',
          meta: {
            id: 'Destination Avail Dashboard',
            icon: 'ProfileFilled',
            code: '014002007011',
            requireAuth: true
          },
          component: () => import('@/view/DC-Data-Center/DestinationAvail/index')
        },
        {
          name: 'Hotel Operation Index',
          meta: {
            id: 'Hotel Operation Index',
            icon: 'SlidersOutlined',
            code: ['014002007004', '014002005002', '014002005003']
          },
          children: [
            {
              name: 'DC Hotel List',
              path: '/OperateAnalysis/DCHotelMonitor/Index',
              meta: {
                id: 'Hotel Status',
                icon: 'ProfileFilled',
                code: '014002007004',
                requireAuth: true
              },
              component: () => import('@/view/DC-Data-Center/Hotel-Operation-Index/Hotel-Status')
            },

            {
              name: 'Hotel Status',
              path: '/OperateAnalysis/HotelStatusReport/Index',
              meta: {
                id: 'Hotel Status Report',
                icon: 'ProfileFilled',
                code: '014002007007',
                requireAuth: true
              },
              component: () =>
                import('@/view/DC-Data-Center/Hotel-Operation-Index/Hotel-Status-Report')
            },
            {
              name: 'Hotel Availability',
              path: '/OperateAnalysis/HotelAvailability/Index',
              meta: {
                id: 'Hotel Availability',
                icon: 'ProfileFilled',
                code: '014002007006',
                requireAuth: true
              },
              component: () =>
                import('@/view/DC-Data-Center/Hotel-Operation-Index/Hotel-Availability')
            },
            {
              name: 'Rate Competitiveness',
              meta: {
                id: 'Rate Competitiveness',
                icon: 'SlidersOutlined',
                code: ['014002005002', '014002005003']
              },
              children: [
                {
                  name: 'RateShop-Single Hotel',
                  path: '/DCCenter/OperateAnalysis/RateShop/RateShop',
                  meta: {
                    id: 'RateShop-Single Hotel',
                    icon: 'ProfileFilled',
                    code: '014002005002'
                  },
                  component: () => import('@/view/OperateAnalysis/RateShop')
                },
                {
                  name: 'RateShop-Multiple Hotel',
                  path: '/DCCenter/OperateAnalysis/RateShop2/RateShopV2',
                  meta: {
                    id: 'RateShop-Multiple Hotel',
                    icon: 'ProfileFilled',
                    code: '014002005003'
                  },
                  component: () => import('@/view/OperateAnalysis/RateShopV2')
                },
                {
                  name: 'Hotel Competitiveness Report',
                  path: '/DCCenter/OperateAnalysis/Rate-Competitiveness/Hotel-Competitiveness-Report/index',
                  meta: {
                    id: 'Hotel Competitiveness Report',
                    icon: 'ProfileFilled',
                    code: '014002007009'
                  },
                  component: () =>
                    import(
                      '@/view/DC-Data-Center/Hotel-Operation-Index/Rate-Competitiveness/Hotel-Competitiveness-Report'
                    )
                }
              ]
            }
          ]
        },
        {
          name: 'Hotel Business Performance',
          meta: {
            id: 'Hotel Business Performance',
            code: '014002007001',
            icon: 'SlidersOutlined',
            requireAuth: true
          },
          children: [
            {
              name: 'General Report',
              meta: {
                id: 'General Report',
                icon: 'SlidersOutlined',
                code: ['014002007002', '014002005001']
              },
              children: [
                {
                  name: 'Production Report',
                  path: '/DCCenter/OperateAnalysis/ProductionReportMonitor/Index',
                  meta: {
                    id: 'Production Report',
                    icon: 'ProfileFilled',
                    code: '014002005001'
                  },
                  component: () => import('@/view/OperateAnalysis/ProductionReportMonitor/Index')
                },
                {
                  name: 'DC Data&GP Report',
                  meta: {
                    id: 'DC Data&GP Report',
                    icon: 'ProfileFilled',
                    code: '014002007002'
                  },
                  children: [
                    {
                      name: 'DC Data Report',
                      path: '/OperateAnalysis/DCDataReport/Index',
                      meta: {
                        id: 'Production Report',
                        icon: 'ProfileFilled',
                        code: '014002005001'
                      },
                      component: () =>
                        import(
                          '@/view/DC-Data-Center/Hotel-Business-Performance/General-Report/DC-Data-And-Gp-Report'
                        )
                    },
                    {
                      name: 'Intl chain report',
                      path: '/OperateAnalysis/DCDataReport/International',
                      meta: {
                        id: 'Intl chain report',
                        icon: 'ProfileFilled',
                        code: '014002007002002'
                      },
                      component: () => import('@/view/DC-Data-Center/Kpi/International')
                    }
                  ]
                }
              ]
            },
            {
              name: 'Detail Data',
              meta: {
                id: 'Detail Data',
                icon: 'SlidersOutlined',
                code: [
                  '014002003002001',
                  '014002003002002',
                  '014002003002003',
                  '014002007003',
                  '014002007001',
                  '014002007005'
                ]
              },
              children: [
                {
                  name: 'Booking Ranking',
                  path: '/DCCenter/V2/BookingRank/Supplier',
                  meta: {
                    id: 'Booking Ranking',
                    icon: 'ProfileFilled',
                    code: '014002003002001'
                  },
                  component: () => import('@/view/V2/BookingRank/Supplier')
                },
                {
                  name: 'Booking Status',
                  path: '/DCCenter/V2/BookingTrend/Supplier',
                  meta: {
                    id: 'Booking Status',
                    icon: 'ProfileFilled',
                    code: '014002003002002'
                  },
                  component: () => import('@/view/V2/BookingTrend/Supplier')
                },
                {
                  name: 'Booking Tendency',
                  path: '/DCCenter/V2/BookingTendency/Supplier',
                  meta: {
                    id: 'Booking Tendency',
                    icon: 'ProfileFilled',
                    code: '014002003002003'
                  },
                  component: () => import('@/view/V2/BookingTendency/Supplier')
                },
                {
                  name: 'DC Chain Data Report',
                  path: '/OperateAnalysis/ChainProductionReportMonitor/Index',
                  meta: {
                    id: 'DC Chain Data Report',
                    icon: 'ProfileFilled',
                    code: '014002007003'
                  },
                  component: () =>
                    import(
                      '@/view/DC-Data-Center/Hotel-Business-Performance/Detail-Data/DC-Chain-Data-Report'
                    )
                },
                {
                  name: 'Dida RN Share',
                  path: '/OperateAnalysis/PerformanceMonitor/Index',
                  meta: {
                    id: 'Dida RN Share',
                    icon: 'ProfileFilled',
                    code: '014002007001'
                  },
                  component: () =>
                    import(
                      '@/view/DC-Data-Center/Hotel-Business-Performance/Detail-Data/Dida-RN-Share'
                    )
                },
                {
                  name: 'DC Prepayment Data',
                  path: '/OperateAnalysis/DCPrepaymentData/Index',
                  meta: {
                    id: 'DC Prepayment Data',
                    icon: 'ProfileFilled',
                    code: '014002007008'
                  },
                  component: () =>
                    import(
                      '@/view/DC-Data-Center/Hotel-Business-Performance/Detail-Data/DC-Prepayment-Data'
                    )
                },
                // {
                //   name: 'DC Prepayment Summary',
                //   path: '/OperateAnalysis/DCPrepaymentSummary/Index',
                //   meta: {
                //     id: 'DC Prepayment Summary',
                //     icon: 'ProfileFilled',
                //     code: '014002007010'
                //   },
                //   component: () =>
                //     import(
                //       '@/view/DC-Data-Center/Hotel-Business-Performance/Detail-Data/DC-Prepayment-Summary'
                //     )
                // },
                {
                  name: 'Hotel Monthly Report',
                  path: '/OperateAnalysis/DCHotelMonthlyMonitor/Index',
                  meta: {
                    id: 'Hotel Monthly Report',
                    icon: 'ProfileFilled',
                    code: '014002007005'
                  },
                  component: () =>
                    import(
                      '@/view/DC-Data-Center/Hotel-Business-Performance/Detail-Data/Hotel-Monthly-Report'
                    )
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: '道旅数据大盘',
      meta: {
        id: 225,
        code: '014002006',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: '总体2',
          path: '/BI/Screen3/Index',
          meta: {
            id: 226,
            icon: 'ProfileFilled',
            code: '014002006001',
            showLayout: false,
            requireAuth: false
          },
          component: () => import('@/view/data-market/BigData')
        },

        {
          name: '订单雷达',
          path: '/BI/Screen4/Index',
          meta: {
            id: 228,
            icon: 'ProfileFilled',
            code: '014002006003',
            showLayout: false
          },
          component: () => import('@/view/BI/Screen4')
        },
        {
          name: '大盘数据看板',
          path: '/OperateAnalysis/DecisionMakingMonitor/Index',
          meta: {
            id: 229,
            icon: 'ProfileFilled',
            code: '014002006004'
          },
          component: () => import('@/view/OperateAnalysis/DecisionMakingMonitor/Index')
        },
        {
          name: '取消罚金利润看板',
          path: '/OperateAnalysis/PolicyBookingReport/Index',
          meta: {
            id: 210,
            icon: 'ProfileFilled',
            code: '014002006004'
          },
          component: () => import('@/view/OperateAnalysis/PolicyBookingReport')
        },
        {
          name: '经营数据',
          meta: {
            id: 230,
            code: '014002006005',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          children: [
            {
              name: '成本数据',
              path: '/Cost/CostDashBoard/CostData',
              meta: {
                id: 231,
                icon: 'ProfileFilled',
                code: '014002006005004',
                requireAuth: true
              },
              component: () => import('@/view/OperateAnalysis/Cost/index')
            },
            // {
            //   name: 'Dashboard',
            //   path: '/Cost/CostDashBoard/CostDashboard',
            //   meta: {
            //     id: 232,
            //     icon: 'ProfileFilled',
            //     code: '014002006005005',
            //     requireAuth: true,
            //     query: { shareType: 0 }
            //   },
            //   component: () => import('@/view/OperateAnalysis/Cost/dashboard')
            // },
            {
              name: 'Dashboard',
              path: '/Cost/CostDashBoard/CostDashboard',
              meta: {
                id: 234,
                icon: 'ProfileFilled',
                code: '014002006005005',
                requireAuth: true,
                //query: { shareType: 1 }
              },
              component: () => import('@/view/OperateAnalysis/Cost/dashboard')
            },
            {
              name: '工时数据',
              path: '/Cost/CostDashBoard/workHour',
              meta: {
                id: 233,
                icon: 'ProfileFilled',
                code: '014002006005006',
                requireAuth: true
              },
              component: () => import('@/view/OperateAnalysis/Cost/workHour')
            }
          ]
        },
        {
          name: 'DC经营数据',
          meta: {
            id: 14002006006,
            code: '014002006006',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          children: [
            {
              name: 'DC成本数据',
              path: '/Cost/CostDashBoard/DCCostData',
              meta: {
                id: 140020060061,
                icon: 'ProfileFilled',
                code: '014002006006001',
                requireAuth: true,
                query: { costType: 201 }
              },
              component: () => import('@/view/OperateAnalysis/Cost/regionIndex')
            },
            {
              name: 'DC Dashboard',
              path: '/Cost/CostDashBoard/DCDashboard',
              meta: {
                id: 140020060062,
                icon: 'ProfileFilled',
                code: '014002006006002',
                requireAuth: true,
                query: { costType: 201 }
              },
              component: () => import('@/view/OperateAnalysis/Cost/regionDashboard')
            }
          ]
        },
        {
          name: 'ACQ经营数据',
          meta: {
            id: 14002006007,
            code: '014002006007',
            icon: 'ProfileFilled',
            requireAuth: true
          },
          children: [
            {
              name: 'ACQ成本数据',
              path: '/Cost/CostDashBoard/ACQCostData',
              meta: {
                id: 140020060071,
                icon: 'ProfileFilled',
                code: '014002006007001',
                requireAuth: true,
                query: { costType: 204 }
              },
              component: () => import('@/view/OperateAnalysis/Cost/regionIndex')
            },
            {
              name: 'ACQ Dashboard',
              path: '/Cost/CostDashBoard/ACQDashboard',
              meta: {
                id: 140020060072,
                icon: 'ProfileFilled',
                code: '014002006007002',
                requireAuth: true,
                query: { costType: 204 }
              },
              component: () => import('@/view/OperateAnalysis/Cost/regionDashboard')
            }
          ]
        }

      ]
    },
    {
      name: 'Market Data Center',
      meta: {
        id: 401,
        code: '014002017',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: 'Oversea CoreData Report',
          path: '/OperateAnalysis/CoreData/Oversea/Index',
          meta: {
            id: 402,
            icon: 'ProfileFilled',
            code: '014002017001',
            showLayout: true,
            requireAuth: true
          },
          component: () => import('@/view/OperateAnalysis/CoreData/Oversea/Index')
        }
      ]
    },
    {
      name: 'Booking Indicator Board',
      meta: {
        id: 313,
        code: '014002016',
        icon: 'SlidersOutlined'
      },
      children: [
        {
          name: 'Real-time Data',
          path: '/OperateAnalysis/DataOverviewMonitor/RealTimeData',
          meta: {
            id: 314,
            icon: 'SlidersOutlined',
            code: ['014002016003', '014002016004','014002016016']
          },
          component: () => import('@/view/OperateAnalysis/DataOverviewMonitor/RealTimeData')
        },
        {
          name: 'Customize search',
          path: '/OperateAnalysis/DataOverviewMonitor/DataByDate',
          meta: {
            id: 315,
            icon: 'SlidersOutlined',
            code: ['014002016013', '014002016014']
          },
          component: () => import('@/view/OperateAnalysis/DataOverviewMonitor/DataByDate')
        }
      ]
    },
    // {
    //   name: 'BI DashBoard配置中心',
    //   meta: {
    //     id: 1000000,
    //     icon: 'SlidersOutlined',
    //     code: '014002014'
    //   },
    //   children: [
    //     {
    //       name: '新建/修改Dashboard',
    //       path: '/BI/Dashboard/DashboardEditIndex',
    //       meta: {
    //         id: 10000001,
    //         icon: 'ProfileFilled',
    //         code: '014002014001',
    //         goOld: true
    //       }
    //     },
    //     {
    //       name: '新建/修改数据集',
    //       path: '/BI/DataSet/Index',
    //       meta: {
    //         id: 10000002,
    //         icon: 'ProfileFilled',
    //         code: '014002014002',
    //         goOld: true
    //       }
    //     },
    //     {
    //       name: '设置Dashboard权限',
    //       path: '/BI/DashboardPermission/Index',
    //       meta: {
    //         id: 10000003,
    //         icon: 'ProfileFilled',
    //         code: '014002014003',
    //         goOld: true
    //       }
    //     }
    //   ]
    // },
    {
      name: 'KPI Dashboard',
      meta: {
        id: 19999,
        icon: 'SlidersOutlined',
        code: '014002011'
      },
      children: [
        {
          name: 'KPI  Dashboard',
          path: '/OperateAnalysis/KPIMonitor/Index',
          meta: {
            id: 199991,
            icon: 'ProfileFilled',
            code: '014002011002'
          },
          component: () => import('@/view/OperateAnalysis/KPIMonitor/KPIMonitor')
        },
        {
          name: '2025 KPI  Dashboard',
          path: '/OperateAnalysis/KPIMonitor/Index-new',
          meta: {
            id: 199991,
            icon: 'ProfileFilled',
            code: '014002011002'
          },
          component: () => import('@/view/OperateAnalysis/KPIMonitor/KPIMonitorv2')
        },
        // {
        //   name: '2026 KPI  Dashboard',
        //   path: '/OperateAnalysis/KPIMonitor/Index-2026',
        //   meta: {
        //     id: 199991,
        //     icon: 'ProfileFilled',
        //     code: '014002011002'
        //   },
        //   component: () => import('@/view/OperateAnalysis/KPIMonitor/KPIMonitor2026')
        // },
        {
          name: 'KPI Dashboard Setting',
          path: '/OperateAnalysis/KPIMonitor/setting',
          meta: {
            id: 199992,
            icon: 'ProfileFilled',
            code: (user) => {
              return [
                '1ae64660-9980-4f9c-8576-8fcfa37abc3f',
                '6ac33756-7635-4ace-a810-900cb2eb17a0',
                '34d637e6-9e50-44da-9869-0787c7fb9998',
                'ee809302-b184-404f-b105-4e55019efdbe',
                '9ebe14ce-61aa-4e4f-b4d4-3c949b180af2',
                '0bd9cbfa-37bb-4446-aea4-ab367d597785',
                '3283ef1c-ef6b-49d9-83f8-6f0809c5b6fe',
                'ca90adb9-703b-4e72-81d9-a137ee7fbc0b',
                '08dce028-09dc-4b8c-86a3-63314bde2bfd',
                'e340f079-aa32-42c6-b3cf-24183aba5a45'
              ].includes(String(user.userID))
            }
          },
          component: () => import('@/view/OperateAnalysis/KPIMonitor/KPIMonitorSetting')
        },
        {
          name: 'Process KPI',
          path: '/OperateAnalysis/ProcessKPI/Index',
          meta: {
            id: 199994,
            icon: 'ProfileFilled',
            code: '014002011004'
          },
          component: () => import('@/view/OperateAnalysis/ProcessKpi/KpiDashboard')
        },
        {
          name: 'Process KPI Setting',
          path: '/OperateAnalysis/ProcessKPI/Setting',
          meta: {
            id: 199995,
            icon: 'ProfileFilled',
            code: '014002011005'
          },
          component: () => import('@/view/OperateAnalysis/ProcessKpi/KpiSetting')
        }
      ]
    },
    {
      name: '内容运营',
      meta: {
        id: 20000,
        icon: 'SlidersOutlined',
        code: '014002012'
      },
      children: [
        {
          name: 'HotelMapping Report',
          path: '/ContentOperation/HotelMapping/Index',
          meta: {
            id: 200001,
            icon: 'ProfileFilled',
            code: '014002012001'
          },
          component: () => import('@/view/ContentOperation/ContentOperation')
        }
      ]
    },
    {
      name: 'Analysis系统日志',
      meta: {
        id: 20001,
        icon: 'SlidersOutlined',
        code: (user) => {
          return [
            'cb3135c7-5397-45bb-aeb9-31cc3641c433',
            'd50d4fb8-9729-4915-aa47-d93b1ea553da'
          ].includes(String(user.userID))
        }
      },
      children: [
        {
          name: 'LogSearch',
          path: '/v2/LogSearch/Index',
          meta: {
            id: 200011,
            icon: 'ProfileFilled',
            code: ''
          },
          component: () => import('@/view/V2/LogSearch/LogSearch')
        }
      ]
    },
    {
      name: '开发测试页面',
      path: '/DevTest',
      meta: {
        id: 9999999,
        icon: 'ProfileFilled',
        code: 'JustForDevTest'
      },
      component: () => import('@/view/ForTest')
    }
  ]
}

export default getMenu()
